// extracted by mini-css-extract-plugin
export default {"container":"Summary_container__ySOIw","options":"Summary_options__h9yCk","loading":"Summary_loading__j+dtn","inner":"Summary_inner__HoKek","offscreen":"Summary_offscreen__q+OTo"};